import { render, staticRenderFns } from "./InfoAssignDepartment.vue?vue&type=template&id=1cc7aee2&"
import script from "./InfoAssignDepartment.vue?vue&type=script&lang=js&"
export * from "./InfoAssignDepartment.vue?vue&type=script&lang=js&"
import style0 from "./InfoAssignDepartment.vue?vue&type=style&index=0&id=1cc7aee2&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports